<template>
  <div style="padding-right:95px; padding-left:95px">
    <div>
      <CButton
          type="submit"
          color="success"
          class="btn btn-sm btn-success pull-right"
          @click="PrintPage"
        >Print Receipt</CButton>
    </div>
    <br><br>
    <div id="printsection">
    <div style="background-color: black; color: white; width: 100%; padding: 5px; text-align: center; font-weight: bold;">
      S A L A R Y  S L I P
    </div>
    <br>
    <CRow>
  <!-- One-row layout -->
  <CRow class="d-flex" style="align-items: flex-start;width: 97%;margin: 0 auto;">
    <!-- Column 1 -->
    <div style="flex: 0 0 20%; max-width: 20%;overflow: hidden;">
      <div>
        <img :src="getPic(teacher.ProfilePicture)" style="width:100px; height:100px;">
        <div>PICKIDDO</div>
      </div>
    </div>

    <!-- Column 2 -->
    <div style="flex: 0 0 40%; max-width: 40%; font-size: 17px; font-weight: 300; overflow: hidden;">
      <div>{{ teacher.TuitionCenterDescription }}</div>
      <div>Phone: {{ teacher.TuitionCenterPhone }}</div>
    </div>

    <!-- Column 3 -->
    <div style="flex: 0 0 40%; max-width: 40%; overflow: hidden;">
      <table class="table table-bordered" style="margin-bottom: 0; width: 100%;">
        <tr>
          <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Employee Name</td>
          <td class="text-right" style="padding:5px; border: 1px solid black;">{{ teacher.TeacherName }}</td>
        </tr>
        <tr>
          <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Employee ID</td>
          <td class="text-right" style="padding:5px; border: 1px solid black;">{{ teacher.Id }}</td>
        </tr>
        <tr>
          <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Pay Period Date</td>
          <td class="text-right" style="padding:5px; border: 1px solid black;">{{ teacher.PeriodDate }}</td>
        </tr>
        <tr>
          <td style="background-color:#2f9e9e; color:#fff; padding:5px; border: 1px solid black;">Rate</td>
          <td class="text-right" style="padding:5px; border: 1px solid black;">RM {{ teacher.Rate }}</td>
        </tr>
      </table>
    </div>
  </CRow>
  </CRow>



    <br>
    <br>

    <CRow>
    <CCol md="12">
      <div>
          <table style="width: 100%; border-bottom: 1px solid #000; border-top: 1px solid #000; border-left: 1px solid #000; border-right: 1px solid #000; ">
            <tr>
              <th colspan="2" style="width: 55%; background-color:#2f9e9e; color:#fff; padding: 5px; border-bottom: 1px solid #000; border-right: 1px solid #000;">Description</th>
              <th colspan="2" style="width: 45%; background-color:#2f9e9e; color:#fff; padding: 5px; border-bottom: 1px solid #000; border-right: 1px solid #000;">Amount</th>
            </tr>
            <tr>
              <td colspan="2" style="padding: 5px; border-bottom: 1px solid #000;"></td>
              <td style="padding: 5px; border-bottom: 1px solid #000; border-left: 1px solid #000;">Earning</td>
              <td style="padding: 5px; border-bottom: 1px solid #000; border-left: 1px solid #000;">Deduction</td>
            </tr>
            <tr>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000; top:0px">Regular Earning</td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;">
              <ul v-for="item in teacher.PaymentRecords" v-bind:key="item.Id">
                <li>{{ item.SubjectName }}</li>
                </ul>
              </td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;">
                 <ul v-for="item in teacher.PaymentRecords" v-bind:key="item.Id">
                <li>RM {{ item.TotalPayment }}</li>
                </ul>
              </td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"></td>
            </tr>
            <tr>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;">Additional Payment</td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"> 
                 <ul v-for="item in teacher.Additional" v-bind:key="item.Id">
                <li>RM {{ item.PaymentInfo }}</li>
                </ul>
              </td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;">
               <ul v-for="item in teacher.Additional" v-bind:key="item.Id">
                <li>RM {{ item.PaymentFee}}</li>
                </ul></td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"></td>
            </tr>
            <tr>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;">Others</td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"></td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"></td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"></td>
            </tr>
            <tr>
              <td colspan="2" style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"><br></td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"></td>
              <td style="padding: 5px; border-left: 1px solid #000; border-bottom: 1px solid #000;"></td>
            </tr>
            <tr>
              <th colspan="2" style="padding: 5px; background-color:#2f9e9e; color:#fff; ">Net Salary</th>
              <th style="padding: 5px; border-left: 1px solid #000; background-color:#ededed;">Total</th>
              <th style="padding: 5px; background-color:#ededed;">RM {{ teacher.Rate }}</th>
            </tr>
          </table>
        </div>
      </CCol>
    </CRow>

    <br>
    <div class="mt-0 text-center">T E R M S</div>
    <hr>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
import $ from "jquery";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);
import jQuery from "jquery";


import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
    "../assets/css/pagebreak.css"
  ]
};
Vue.use(VueHtmlToPaper, options);

export default {
  components: {
    PulseLoader,
  },
  data() {
    return {
      teacher: {},
    }
  },
  async mounted() {
      this.GetPaymentSlip();
  },
  methods: {
      GetPaymentSlip() {
      this.Busy = true;
      this.$API
      .get(this.$GetSlipTeacher + "?teacherId=" + this.$route.query.teacherId + "&monthName=" + this.$route.query.monthName, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.Busy = false;
            this.teacher = response.data;
             this.getPic(teacher.ProfilePicture);
          }
        });
    },
       getPic(receipt) {
      return "https://54.254.198.108/File" + receipt;
    },
    PrintPage() {
      const printContent = document.getElementById("printsection");
  const windowPrint = window.open("", "_blank");
  windowPrint.document.write(`
    <html>
      <head>
        <title>Print Receipt</title>
        <style>
          @media print {
            body { margin: 0; padding: 0; }
            .d-flex { display: flex; flex-wrap: nowrap; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid black; padding: 5px; text-align: left; }
            .table-bordered { border: 1px solid black; }
          }
        </style>
      </head>
      <body>
        <div>${printContent.innerHTML}</div>
      </body>
    </html>
  `);
  windowPrint.document.close();
  windowPrint.print();
  windowPrint.close();
}
  }
}
</script>

<style>
table-head {
  width: 25%; 
  background-color:#2f9e9e; 
  color:#fff; 
  padding: 5px; 
  border-bottom: 1px solid #000; 
  border-right: 1px solid #000;
}
@media print {
  body {
    margin: 0;
    padding: 0;
  }

  #printsection {
    width: 100%;
    padding: 20px;
    color: black;
    font-size: 14px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    border: 1px solid black;
    padding: 5px;
    text-align: left;
  }

  .btn, .btn-success, .pull-right {
    display: none; /* Hide buttons during print */
  }
}
</style>
